'use strict';

function ctrl($scope, Global, $location, settings, $http, usSpinnerService) {
    let model = this;

    $scope.global = Global;
    model.settings = settings;

    $http({
            method: 'GET',
            url: api + '/api/stealth/stealth_op_view/coi_chart'
        })
        .success(function(data) {
            $scope.forcedata = data;
            $scope.$broadcast('forceChart', data);
            usSpinnerService.stop('spinner-stealth_op_view');
        });

    model.save_coordinates = function(node) {
        $http({
            method: 'POST',
            url: api + '/api/stealth/stealth_op_view/save_coordinates',
            data: {
                x: node.x,
                y: node.y,
                type: node.group,
                name: node.name
            }
        });
    }

    $scope.onloadInfo = function() {
        var nodeInfo = [];
        var nodeName = [];
        for (var i in $scope.forcedata.uniqueNodes) {
            var nodeAppend = [];
            $scope.forcedata.nodes.filter(function(d) {
                if (i === d.name) {
                    nodeAppend['Name'] = d.name;
                    nodeAppend['User Count'] = d.count;
                    nodeAppend['index'] = d.index;
                }
            });
            nodeAppend['Blocked'] = 0;
            $scope.forcedata.links.filter(function(d) {
                if ((d.class !== undefined) && ((d.target.index === nodeAppend['index']) || (d.source.index === nodeAppend['index']))) {
                    if (d.allowed === 'authorized') {
                        // nodeAppend['allowed']++;
                    } else if (d.allowed === 'blocked') {
                        nodeAppend['Blocked']++;
                    }
                }
            });
            nodeInfo.push(nodeAppend);
        }
        $scope.pageLoadInfo(nodeInfo, 'onload');
    }
    $scope.requery = function(data, button) {
        var results = [];
        switch (button) {
            case 'rules':
                $scope.appendInfo(data, 'rules');
                break;
            case 'authorized':
                // get children hanging off of parent nodes
                var rTargets = $scope.forcedata.links.filter(function(d) {
                    if ((d.class !== undefined) && (d.source.index === data.index) && (d.source.value.allowed === 'authorized')) {
                        return true;
                    }
                })
                var rSource = $scope.forcedata.links.filter(function(d) {
                    if ((d.class !== undefined) && (d.target.index === data.index) && (d.source.value.allowed === 'authorized')) {
                        return true;
                    }
                })
                for (var i in rTargets) {
                    results.push($scope.forcedata.nodes[rTargets[i].target.index].value)
                }
                for (var i in rSource) {
                    results.push($scope.forcedata.nodes[rSource[i].source.index].value)
                }
                $scope.appendInfo(results, 'authorized');
                break;
            case 'blocked':
                // get children hanging off of parent nodes
                var rTargets = $scope.forcedata.links.filter(function(d) {
                    if ((d.class !== undefined) && (d.source.index === data.index) && (d.target.value.allowed === 'blocked')) {
                        return true;
                    }
                })
                var rSource = $scope.forcedata.links.filter(function(d) {
                    if ((d.class !== undefined) && (d.target.index === data.index) && (d.source.value.allowed === 'blocked')) {
                        return true;
                    }
                })
                for (var i in rTargets) {
                    results.push($scope.forcedata.nodes[rTargets[i].target.index].value)
                }
                for (var i in rSource) {
                    results.push($scope.forcedata.nodes[rSource[i].source.index].value)
                }
                $scope.appendInfo(results, 'blocked');
                break;
            case 'users':
                var thisObj = $scope.forcedata.uniqueNodes['' + data.name];
                for (var i in thisObj) {
                    var obj = {};
                    obj[i] = Object.keys($scope.forcedata.uniqueUsers[i]);
                    results.push(obj)
                }
                $scope.appendInfo(results, 'users');
                break;
            case 'top':
                // clear the div (replace with loading thing later)
                query += '&type=top';
                $http({
                        method: 'GET',
                        url: api + query
                    })
                    .success(function(data) {
                        if (data.force === null) {
                            $scope.$broadcast('loadError');
                        }
                    });
                $scope.appendInfo(results, 'top');
                break;
        }
    }
}

ctrl.$inject = ['$scope', 'Global', '$location', 'settings', '$http', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/stealth/stealth_op_view.js
 **/